import React, { FC, PropsWithChildren } from 'react';
import styles from './footer.module.scss';

export const Footer: FC<PropsWithChildren> = ({ children }) => (
    <div className={styles.footer}>{children}</div>
);
